import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addZToUTC',
  standalone: true,
})
export class AddZToUTCPipe implements PipeTransform {
  transform(value: string | null): string | null {
    if (!value) {
      return '';
    }

    if (!value.endsWith('Z')) {
      return value + 'Z';
    }
    return value;
  }
}
